<template>
  <BaseDialog
    :isOpen="isOpen"
    :title="title"
    @close="$emit('close')"
    @cancel="$emit('cancel')"
    @confirm="onConfirm"
    :hidePrimaryBtn="!canEdit"
  >
    <v-form :readonly="!canEdit" lazy-validation ref="upsertGraduationDialog">
      <v-card-text>
        <p class="mb-2 text-subtitle-1">Thông tin cơ bản</p>
        <div class="pl-2">
          <autocomplete-student
            v-model="formData.student"
            label="Tìm kiếm học sinh"
            dense
            return-object
            class="pt-4"
            :rules="[$rules.required]"
            v-if="!isEdit && !fixedStudent"
          />
          <date-selector
            :disabled="!canEdit"
            label="Ngày bắt đầu"
            :rules="[$rules.required]"
            :date="transformDateForDatePicker(formData.start_date)"
            @change="onStartDateChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày kết thúc"
            :date="transformDateForDatePicker(formData.end_date)"
            @change="onEndDateChange"
            :rules="[$rules.required]"
          ></date-selector>
          <v-text-field
            label="Điểm trung bình"
            v-model="formData.overall_average"
            type="number"
            step="0.5"
            min="0"
            max="10"
            :rules="[$rules.required]"
          ></v-text-field>
          <v-select
            :items="getStudentRankList"
            item-value="value"
            item-text="label"
            v-model="formData.rank"
            label="Xếp loại"
            :rules="[$rules.required]"
          >
          </v-select>
          <v-text-field
            label="Số bằng"
            v-model="formData.certificate_number"
            :rules="[$rules.required]"
          ></v-text-field>
          <date-selector
            :disabled="!canEdit"
            label="Ngày cấp bằng Monster Lab"
            :date="transformDateForDatePicker(formData.certificate_date_monster_lab)"
            @change="onCertificateDateMonsterLabChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày cấp bằng CC Training"
            :date="transformDateForDatePicker(formData.certificate_date_cc_training)"
            @change="onCertificateDateCCTrainingChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày cấp bằng Đại học"
            :date="transformDateForDatePicker(formData.certificate_date_college)"
            @change="onCertificateDateCollegeChange"
          ></date-selector>
          <v-text-field
            label="Bằng CDNT"
            v-model="formData.college_certificate_cdnt"
          ></v-text-field>
          <v-checkbox label="Đã tốt nghiệp" v-model="formData.graduated"></v-checkbox>
          <v-textarea rows="3" label="Ghi chú" v-model="formData.note"></v-textarea>
        </div>
      </v-card-text>
    </v-form>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import DateSelector from '@/components/basic/DateSelector.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import { getStudentRankList, transformDateForDatePicker } from '../helpers'

export default {
  components: {
    DateSelector,
    AutocompleteStudent,
    BaseDialog
  },
  data() {
    return {
      formData: cloneDeep(this.currentItem)
    }
  },
  props: {
    currentItem: Object,
    isOpen: Boolean,
    isEdit: Boolean,
    fixedStudent: Boolean
  },
  computed: {
    getStudentRankList() {
      return getStudentRankList()
    },
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    title() {
      if (this.isEdit) {
        return 'Cập nhật tốt nghiệp'
      }
      return 'Tạo mới tốt nghiệp'
    }
  },
  methods: {
    transformDateForDatePicker,
    onStartDateChange(value) {
      this.formData.start_date = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onEndDateChange(value) {
      this.formData.end_date = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onCertificateDateMonsterLabChange(value) {
      this.formData.certificate_date_monster_lab = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onCertificateDateCCTrainingChange(value) {
      this.formData.certificate_date_cc_training = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onCertificateDateCollegeChange(value) {
      this.formData.certificate_date_college = moment(value, 'YYYY-MM-DD').toISOString()
    },
    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onConfirm() {
      if (this.$refs.upsertGraduationDialog.validate()) {
        this.$emit('confirm', this.formData)
      }
    }
  }
}
</script>
